import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link as RouterLink } from "react-router-dom";

const CONSENT_STORAGE_KEY = "cookie-consent";

type ConsentChoice = "all" | "essential";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [hasHydrated, setHasHydrated] = useState(false);

  useEffect(() => {
    // Guard against SSR/early hydration
    setHasHydrated(true);
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY) as ConsentChoice | null;
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const handleChoice = (choice: ConsentChoice) => {
    localStorage.setItem(CONSENT_STORAGE_KEY, choice);
    setVisible(false);
    // If we had non-essential scripts, we'd conditionally load them when "all" is chosen.
  };

  if (!hasHydrated || !visible) return null;

  return (
    <div className="fixed right-3 bottom-3 z-50 w-[92vw] max-w-md md:right-6 md:bottom-6">
      <div className="rounded-lg border bg-card shadow-xl p-4 md:p-5 backdrop-blur-sm">
        <div className="flex items-start gap-3">
          <div className="flex-1 space-y-1.5">
            <p className="text-sm font-semibold text-foreground">Cookies & data</p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              Essential cookies keep you signed in and secure. Analytics/performance cookies are optional.
            </p>
            <RouterLink to="/privacy" className="text-[11px] text-primary underline">
              Privacy details
            </RouterLink>
          </div>
          <div className="flex flex-col gap-2 w-32">
            <Button variant="outline" size="sm" onClick={() => handleChoice("essential")}>
              Essential
            </Button>
            <Button size="sm" onClick={() => handleChoice("all")}>
              Accept all
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
